var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    d: "M10.02 13.5749C10.02 12.995 9.58125 12.5249 9.04001 12.5249H6.59002C6.04878 12.5249 5.61002 12.995 5.61002 13.5749V17.2499C5.61002 17.8298 5.17126 18.2999 4.63002 18.2999H1.20003C0.658792 18.2999 0.220032 18.77 0.220032 19.3499V21.9749C0.220032 22.5548 0.658792 23.0249 1.20003 23.0249H6.10002C8.26497 23.0249 10.02 21.1445 10.02 18.8249V13.5749Z",
    fill: "#54AEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    d: "M4.14002 0.975098C1.97507 0.975098 0.220032 2.8555 0.220032 5.17509V7.27508C0.220032 9.59467 1.97507 11.4751 4.14002 11.4751H9.04001C9.58125 11.4751 10.02 11.005 10.02 10.4251V7.80008C10.02 7.22018 9.58125 6.75008 9.04001 6.75008H5.61002C5.3394 6.75008 5.12002 6.51503 5.12002 6.22509C5.12002 5.93514 5.3394 5.70009 5.61002 5.70009H9.04001C9.58125 5.70009 10.02 5.22999 10.02 4.65009V2.0251C10.02 1.4452 9.58125 0.975098 9.04001 0.975098H4.14002Z",
    fill: "#218BFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.86 0.975098H11.98C11.4388 0.975098 11 1.4452 11 2.0251V10.4251C11 11.005 11.4388 11.4751 11.98 11.4751H17.86C20.0249 11.4751 21.78 9.59467 21.78 7.27508V5.17509C21.78 2.8555 20.0249 0.975098 17.86 0.975098ZM16.88 5.70009C17.1506 5.70009 17.37 5.93514 17.37 6.22509C17.37 6.51503 17.1506 6.75008 16.88 6.75008H15.9C15.6294 6.75008 15.41 6.51503 15.41 6.22509C15.41 5.93514 15.6294 5.70009 15.9 5.70009H16.88Z",
    fill: "#218BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.86 12.5251H11.98C11.4388 12.5251 11 12.9952 11 13.5751V21.975C11 22.5549 11.4388 23.025 11.98 23.025H17.86C20.0249 23.025 21.78 21.1446 21.78 18.8251V16.7251C21.78 14.4055 20.0249 12.5251 17.86 12.5251ZM16.88 17.2501C17.1506 17.2501 17.37 17.4851 17.37 17.7751C17.37 18.065 17.1506 18.3001 16.88 18.3001H15.9C15.6294 18.3001 15.41 18.065 15.41 17.7751C15.41 17.4851 15.6294 17.2501 15.9 17.2501H16.88Z",
    fill: "#218BFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolLogo);
export default __webpack_public_path__ + "static/media/symbol-logo.f8f893f61f781f6db316b74302ca7e34.svg";
export { ForwardRef as ReactComponent };